<template>
    <div class="ent-select-container">
        <div 
            :class="showBg ? 'select-trigger top_bg' : 'select-trigger'" 
            @click="toggleDropdown"
           
        >
            <span class="select-value">{{ selectedLabel || placeholder }}</span>
            <span class="select-icon" :class="{ 'rotate': isOpen }">
                <svg width="12" height="8" viewBox="0 0 12 8" fill="none">
                    <path d="M1 1L6 6L11 1" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </span>
        </div>
        
        <transition name="dropdown">
            <div v-if="isOpen" class="dropdown-menu">
                <div class="dropdown-content">
                    <!-- 搜索输入框 -->
                    <div class="search-container">
                        <input 
                            ref="searchInput"
                            v-model="searchKeyword"
                            type="text"
                            class="search-input"
                            :placeholder="`搜索${keyText}...`"
                            @click.stop
                            @input="handleSearch"
                        />
                        <span class="search-icon">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                <path d="M7 12C9.76142 12 12 9.76142 12 7C12 4.23858 9.76142 2 7 2C4.23858 2 2 4.23858 2 7C2 9.76142 4.23858 12 7 12Z" stroke="currentColor" stroke-width="2"/>
                                <path d="M14 14L10.5 10.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                            </svg>
                        </span>
                    </div>
                    
                    <!-- 选项列表 -->
                    <div class="options-list">
                        <div 
                            v-for="option in filteredOptions" 
                            :key="option[setKey.key]"
                            class="dropdown-item"
                            :class="{ 'selected': selectedValue === option[setKey.key] }"
                            @click="selectOption(option)"
                        >
                            <span class="item-text" v-html="highlightText(option[setKey.label])"></span>
                            <span v-if="selectedValue === option[setKey.key]" class="check-icon">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M13.5 4.5L6 12L2.5 8.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </span>
                        </div>
                        
                        <!-- 无搜索结果提示 -->
                        <div v-if="filteredOptions.length === 0 && searchKeyword" class="no-results">
                            <span class="no-results-text">未找到匹配的{{ keyText }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'SearchDev',
    props: {
        options: {
            type: Array,
            default: () => []
        },
        value: {
            type: [String, Number],
            default: 'all'
        },
        placeholder: {
            type: String,
            default: '请选择设备'
        },
        keyText: {
            type: String,
            default: '设备'
        },
        showBg: {
            type: Boolean,
            default: false
        },
        setKey: {
            type: Object,
            default: () => ({key: 'id', label: 'name'})
        }
    },
    data() {
        return {
            isOpen: false,
            selectedValue: this.value,
            searchKeyword: ''
        }
    },
    computed: {
        selectedLabel() {
            const selected = this.options.find(option => option[this.setKey.key] === this.selectedValue)
            return selected ? selected[this.setKey.label] : ''
        },
        filteredOptions() {
            if (!this.searchKeyword) {
                return this.options
            }
            return this.options.filter(option => 
                option[this.setKey.label].toLowerCase().includes(this.searchKeyword.toLowerCase())
            )
        },

    },
    watch: {
        value(newVal) {
            this.selectedValue = newVal
        }
    },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen
            if (this.isOpen) {
                this.searchKeyword = ''
                // 在下一帧聚焦到搜索框
                this.$nextTick(() => {
                    if (this.$refs.searchInput) {
                        this.$refs.searchInput.focus()
                    }
                })
            }
        },
        selectOption(option) {
            this.selectedValue = option[this.setKey.key]
            this.$emit('input', option[this.setKey.key])
            this.$emit('change', option)
            this.isOpen = false
            this.searchKeyword = ''
        },
        handleSearch() {
            // 搜索逻辑已在 filteredOptions 计算属性中处理
        },
        highlightText(text) {
            if (!this.searchKeyword) {
                return text
            }
            const regex = new RegExp(`(${this.searchKeyword})`, 'gi')
            return text.replace(regex, '<span class="highlight">$1</span>')
        },
        closeDropdown(event) {
            if (!event.target.closest('.ent-select-container')) {
                this.isOpen = false
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.closeDropdown)
    },
    beforeDestroy() {
        document.removeEventListener('click', this.closeDropdown)
    }
}
</script>

<style lang="scss" scoped>
.ent-select-container {
    position: relative;
    width: 240px;
    .top_bg{
        border-bottom: 2px solid #00FFC5;
        background: linear-gradient(to top, rgba(0, 255, 197, 0.4), rgba(0, 0, 0, 0));
    }
    .select-trigger {
        width: 100%;
        height: 34px;
        padding: 0 14px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        transition: all 0.3s ease;
        background: #28353F;
        border: 1px solid rgba(0, 255, 197, 0.3);
        border-radius: 4px;
        &:hover {
            border-color: rgba(0, 255, 197, 0.6);
            background: #2a3a47;
            box-shadow: 
                0 0 25px rgba(0, 255, 197, 0.2),
                inset 0 1px 2px rgba(255, 255, 255, 0.1);
            transform: translateY(-1px);
        }
        &.active {
            border-color: rgba(0, 255, 197, 0.8);
            background: #2a3a47;
            box-shadow: 
                0 0 30px rgba(0, 255, 197, 0.3),
                inset 0 1px 2px rgba(255, 255, 255, 0.1);
        }
        .select-value {
            font-size: 14px;
            color: #FFFFFF;
            font-weight: 500;
            text-shadow: 0 0 8px rgba(0, 255, 197, 0.3);
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-right: 8px;
        }
        .select-icon {
            color: #00FFC5;
            transition: all 0.3s ease;
            display: flex;
            align-items: center;
            justify-content: center;
            filter: drop-shadow(0 0 5px rgba(0, 255, 197, 0.5));
            &.rotate {
                transform: rotate(180deg);
            }
        }
    }
    .dropdown-menu {
        position: absolute;
        top: 120%;
        left: 0;
        right: 0;
        margin-top: 8px;
        z-index: 1000;
        min-width: 240px;
        .dropdown-content {
            max-height: 320px;
            overflow-y: auto;
            overflow-x: hidden;
            background: linear-gradient(135deg, 
                rgba(25, 35, 45, 0.95) 0%,
                rgba(15, 25, 35, 0.95) 100%);
            border: 2px solid rgba(0, 255, 197, 0.3);
            border-radius: 8px;
            box-shadow: 
                0 8px 32px rgba(0, 0, 0, 0.4),
                0 0 20px rgba(0, 255, 197, 0.2),
                inset 0 1px 2px rgba(255, 255, 255, 0.1);
            backdrop-filter: blur(10px);
            &::-webkit-scrollbar {
                width: 6px;
            }
            &::-webkit-scrollbar-track {
                background: rgba(0, 255, 197, 0.1);
                border-radius: 3px;
            }
            &::-webkit-scrollbar-thumb {
                background: linear-gradient(180deg, 
                    #00FFC5 0%,
                    #00BFA1 100%);
                border-radius: 3px;
                box-shadow: 0 0 5px rgba(0, 255, 197, 0.3);
                &:hover {
                    background: linear-gradient(180deg, 
                        #33FFD6 0%,
                        #00FFC5 100%);
                    box-shadow: 0 0 8px rgba(0, 255, 197, 0.5);
                }
            }
            .search-container {
                padding: 10px 14px;
                display: flex;
                align-items: center;
                background: #28353F;
                border-bottom: 1px solid rgba(0, 255, 197, 0.2);
                border-radius: 8px 8px 0 0;
                .search-input {
                    flex: 1;
                    background: #28353F;
                    border: 1px solid rgba(0, 255, 197, 0.3);
                    border-radius: 4px;
                    outline: none;
                    color: #FFFFFF;
                    font-size: 14px;
                    padding: 8px 12px;
                    caret-color: #00FFC5;
                    transition: all 0.3s ease;
                    &::placeholder {
                        color: rgba(255, 255, 255, 0.5);
                    }
                    &:focus {
                        border-color: rgba(0, 255, 197, 0.6);
                        box-shadow: 0 0 8px rgba(0, 255, 197, 0.2);
                        background: #2a3a47;
                    }
                }
                .search-icon {
                    color: #00FFC5;
                    margin-left: 8px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    filter: drop-shadow(0 0 5px rgba(0, 255, 197, 0.5));
                }
            }
            .options-list {
                max-height: 220px;
                overflow-y: auto;
                .dropdown-item {
                    padding: 10px 14px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    position: relative;
                    font-size: 15px;
                    &:not(:last-child) {
                        border-bottom: 1px solid rgba(0, 255, 197, 0.1);
                    }
                    &:hover {
                        background: linear-gradient(135deg, 
                            rgba(0, 255, 197, 0.1) 0%,
                            rgba(0, 255, 197, 0.05) 100%);
                        transform: translateX(4px);
                        &::before {
                            opacity: 1;
                        }
                    }
                    &.selected {
                        background: linear-gradient(135deg, 
                            rgba(0, 255, 197, 0.15) 0%,
                            rgba(0, 255, 197, 0.08) 100%);
                        .item-text {
                            color: #00FFC5;
                            font-weight: 600;
                        }
                    }
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        top: 0;
                        bottom: 0;
                        width: 3px;
                        background: linear-gradient(180deg, 
                            #00FFC5 0%,
                            #00BFA1 100%);
                        opacity: 0;
                        transition: opacity 0.3s ease;
                    }
                    .item-text {
                        font-size: 15px;
                        color: #FFFFFF;
                        font-weight: 500;
                        text-shadow: 0 0 8px rgba(0, 255, 197, 0.2);
                        transition: all 0.3s ease;
                        ::v-deep .highlight {
                            background: rgba(0, 255, 197, 0.3);
                            color: #00FFC5;
                            padding: 2px 4px;
                            border-radius: 4px;
                            font-weight: 700;
                            box-shadow: 0 0 8px rgba(0, 255, 197, 0.4);
                        }
                    }
                    .check-icon {
                        color: #00FFC5;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        filter: drop-shadow(0 0 5px rgba(0, 255, 197, 0.5));
                        animation: checkIn 0.3s ease;
                    }
                }
                .no-results {
                    padding: 10px 14px;
                    text-align: center;
                    color: rgba(255, 255, 255, 0.5);
                    font-size: 14px;
                }
            }
        }
    }
}

// 动画定义
.dropdown-enter-active,
.dropdown-leave-active {
    transition: all 0.3s ease;
}
.dropdown-enter-from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
}
.dropdown-leave-to {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
}
@keyframes checkIn {
    0% {
        opacity: 0;
        transform: scale(0.5);
    }
    100% {
        opacity: 1;
        transform: scale(1);
    }
}
// 响应式设计
@media (max-width: 768px) {
    .ent-select-container {
        width: 100%;
        max-width: 240px;
    }
}
</style>